import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

type StyledButtonProps = {
  right?: boolean
  disabled?: boolean
}

const shouldForwardProp = (prop: string) =>
  !['right', 'disabled'].includes(prop)

const styledButtonRightCss = ({ right }: StyledButtonProps) =>
  right &&
  css`
    left: unset;
    right: 0;
  `

const styledButtonDisabledCss = ({ disabled }: StyledButtonProps) =>
  disabled &&
  css`
    color: ${themeGet('colors.text.disabled')};
    cursor: default;
  `

export const StyledButton = styled.button.withConfig({
  shouldForwardProp,
})<StyledButtonProps>`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: ${themeGet('colors.primary.main')};
  z-index: 2;

  ${styledButtonRightCss}
  ${styledButtonDisabledCss}
`
